module.exports = __webpack_public_path__ + "static/media/app-store-badge.b38348ca.png";